import { Type } from "@sinclair/typebox";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api.js";
export const getPhaseDetailsSchema = Type.Object({
    planId: Type.String(),
    phaseId: Type.String(),
    detailed: Type.Optional(Type.Boolean()),
});
export const getFreemiumPhaseDetails = ({ planId, phaseId, detailed, }) => {
    return api
        .get(`trainingPlans/templates/${planId}/phases/${phaseId}`, {
        searchParams: {
            ...(detailed !== undefined && { detailed }),
        },
    })
        .json();
};
export const getFreemiumPhaseDetailsQueryOptions = (filter) => {
    return queryOptions({
        queryKey: ["freemium_phase_details", filter],
        queryFn: () => getFreemiumPhaseDetails(filter),
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        gcTime: 1000 * 60 * 60, // 1 hour
        staleTime: 1000 * 60 * 60, // 1 hour
    });
};
export const useFreemiumPhaseDetails = ({ queryConfig, filter, }) => {
    return useQuery({
        ...getFreemiumPhaseDetailsQueryOptions(filter),
        ...queryConfig,
    });
};
//# sourceMappingURL=getPhaseDetails.js.map